import config from 'config';

const api_prefix = config.api_prefix;

export default {
  // system
  systemInfo: api_prefix + '/system/systemInfo', // 系统信息，后台系统配置，页面加载加载一次
  notice: api_prefix + '/system/systemNotice', //系统通告信息

  // admin
  travelToUser: api_prefix + '/admin-op/travelToUser', // 模拟登录
  userAdd: api_prefix + '/admin-op/createUser', // 创建用户
  userList: api_prefix + '/admin-op/listUser', // 用户列表
  setConfig: api_prefix + '/admin-op/setConfig post', // config 单条
  setConfigs: api_prefix + '/admin-op/setConfigs post', // config all
  allConfig: api_prefix + '/admin-op/allConfig', // 所有 config
  settingTemplate: api_prefix + '/admin-op/settingTemplate', // 设置配置模版
  listServer: api_prefix + '/admin-op/listServer', // 列出 server
  setServerStatus: api_prefix + '/admin-op/setServerStatus', // 设置服务器状态
  grantAdmin: api_prefix + '/admin-op/grantAdmin', // 授权
  logList: api_prefix + '/admin-op/listSystemLog', // 日志

  // user
  login: api_prefix + '/user-info/login post query', // 登录
  register: api_prefix + '/user-info/register post query', // 注册
  getUser: api_prefix + '/user-info/userInfo', // 获取用户信息
  updatePassword: api_prefix + '/user-info/resetPassword post query', // 修改密码
  refreshToken: api_prefix + '/user-info/refreshToken', // 刷新 token
  regenerateAPIToken: api_prefix + '/user-info/regenerateAPIToken', // 刷新 api token
  permScopes: api_prefix + '/user-info/permScopes',
  permItemsOfScope: api_prefix + '/user-info/permItemsOfScope',
  editUserPerm: api_prefix + '/user-info/editUserPerm post query',

  // metric
  queryMetric: api_prefix + '/metric/queryMetric', // 查询指标
  metricNames: api_prefix + '/metric/metricNames', // 指标列表
  metricTag: api_prefix + '/metric/metricTag', // 指标tag分量
  deleteMetric: api_prefix + '/metric/deleteMetric', // 删除一个指标
  mqlQuery: api_prefix + '/metric/mqlQuery post query', // 使用mql查询指标数据，mql支持指标内容的加工
  allMetricConfig: api_prefix + '/metric/allMetricConfig',

  // 下列为各业务自定义接口
  listProject: api_prefix + '/project/listProject',
  addOrUpdateProject: api_prefix + '/project/addOrUpdateProject post',
  projectDetail: api_prefix + '/project/projectDetail',
  editProjectConfig: api_prefix + '/project/editProjectConfig post query',
  getProjectConfig: api_prefix + '/project/getProjectConfig',
  availableDeviceForProject: api_prefix + '/project/availableDeviceForProject',
  listProjectDevice: api_prefix + '/project/listProjectDevice',
  deleteProjectDevice: api_prefix + '/project/deleteProjectDevice',
  addProjectDeviceBatch:
    api_prefix + '/project/addProjectDeviceBatch post query',
  // device
  editDeviceConfig: api_prefix + '/device/editDeviceConfig post query',
  getDeviceConfig: api_prefix + '/device/getDeviceConfig',
  searchDevice: api_prefix + '/device/searchDevice',
  querySearchGroup: api_prefix + '/device/querySearchGroup',
  grayDeviceList: api_prefix + '/device/grayDeviceList',
  updateDeviceGrayStatus: api_prefix + '/device/updateDeviceGrayStatus',
  normalLogSearch: api_prefix + '/device/normalLogSearch',
  logCursor: api_prefix + '/device/logCursor',
  deviceTopLog: api_prefix + '/device/deviceTopLog',
  listDeviceLog: api_prefix + '/device/listDeviceLog',
  downloadDeviceLog: api_prefix + '/device/downloadDeviceLog',
  deviceDetail: api_prefix + '/device/deviceDetail',
  listDeviceProject: api_prefix + '/device/listDeviceProject',
  listVideoRecord: api_prefix + '/device/listVideoRecord',
  liveWallList: api_prefix + '/device/liveWallList',
  editLiveWall: api_prefix + '/device/editLiveWall post',
  deleteLiveWall: api_prefix + '/device/deleteLiveWall',
  liveWallDetail: api_prefix + '/device/liveWallDetail',
  deviceDetailByUuids: api_prefix + '/device/deviceDetailByUuids',
  deviceDetailByIds: api_prefix + '/device/deviceDetailByIds',
  sandboxActiveTimeLine: api_prefix + '/device/sandboxActiveTimeLine',
  getGlobalRemoteConfig: api_prefix + '/device/getGlobalRemoteConfig',
  setGlobalRemoteConfig: api_prefix + '/device/setGlobalRemoteConfig',

  // assets
  uploadApk: api_prefix + '/assets/uploadApk form',
  listApkAssets: api_prefix + '/assets/listApkAssets',
  deleteApkAssets: api_prefix + '/assets/deleteApkAssets',
  downloadApkAssets: api_prefix + '/assets/downloadApkAssets',
  uploadZedEngine: api_prefix + '/assets/uploadZedEngine form',
  downloadZedEngine: api_prefix + '/assets/downloadZedEngine',
  listZedEngine: api_prefix + '/assets/listZedEngine',
  deleteZedEngine: api_prefix + '/assets/deleteZedEngine',
  activeZedEngineVersion: api_prefix + '/assets/activeZedEngineVersion',

  // sms
  smdMessage: api_prefix + '/sms/smdMessage',
  searchSMS: api_prefix + '/sms/searchSMS',
  enqueueNewPhone: api_prefix + '/sms/enqueueNewPhone',
  submitMsg: api_prefix + '/sms/submitMsg',
  smsTaskList: api_prefix + '/sms/smsTaskList',
  resetPhone: api_prefix + '/sms/resetPhone',
  cancelPhone: api_prefix + '/sms/cancelPhone',

  // shareDisk
  listDir: api_prefix + '/shareDisk/listDir',
  uploadFile: api_prefix + '/shareDisk/uploadFile form',
  downloadFile: api_prefix + '/shareDisk/downloadFile',
  deleteFile: api_prefix + '/shareDisk/deleteFile',
  createDirectory: api_prefix + '/shareDisk/createDirectory',
};
